import {PatientGoalControlTypeEnum, PatientGoalNumberTypeEnum} from '../../enums/patient-goal';
import {IPatientGoal, IPatientGoalSearch, IPostPatientGoal} from '../../models/patient-goal';
import {NzModalService} from 'ng-zorro-antd/modal';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';
import {firstValueFrom} from 'rxjs';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {ICardIconText} from '../../interfaces/card';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-card-patient-goal',
  templateUrl: './card-patient-goal.component.html',
  styleUrls: ['./card-patient-goal.component.scss'],
  animations: [fadeInAnimation]
})
export class CardPatientGoalComponent implements OnInit {
  @Input() goalToCreate: IPostPatientGoal;
  @Input() goal: any;
  @Input() optionsSearch: IPatientGoalSearch[] = [];
  @Input() editMode: boolean;
  /**
   * canInteract - Si es verdadero puede eliminar la meta, en caso contrario no permite esta acción
   */
  @Input() canInteract = false;
  @Output() modify: EventEmitter<string> = new EventEmitter();
  @Output() clone: EventEmitter<string> = new EventEmitter();
  @Output() delete: EventEmitter<Partial<IPostPatientGoal>> = new EventEmitter();
  @Output() deleteAll: EventEmitter<string> = new EventEmitter();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() save: EventEmitter<IPostPatientGoal> = new EventEmitter();

  blockPeriodTypes: ICardIconText[];
  currentDate = new Date();
  isValueRange: boolean;

  patientGoalControlTypeEnum = PatientGoalControlTypeEnum;
  patientGoalType: PatientGoalControlTypeEnum = PatientGoalControlTypeEnum.NUMBER;
  patientGoalNumberType = PatientGoalNumberTypeEnum;
  measurementUnitSymbol: string;
  platformConfig = PLATFORM_CONFIG;

  constructor(
    public utilitiesService: UtilitiesService,
    private store: Store,
    private modal: NzModalService
  ) { }

  ngOnInit(): void {
    this.initValues();
  }

  initValues(): void {
    this.blockPeriodTypes = [
      {
        id: '1',
        label: 'Fijo',
        img: './../../../assets/images/icons/icons8-food-100-2.png'
      },
      {
        id: '2',
        label: 'Rango',
        img: './../../../assets/images/icons/icons8-tomato-100.png'
      }
    ];
  }

  onChangeGoalType(): void {
    this.goalToCreate.goalType = this.goalToCreate.goalType === PatientGoalNumberTypeEnum.VALUE ?
      PatientGoalNumberTypeEnum.BETWEEN_VALUE : PatientGoalNumberTypeEnum.VALUE;
    if (this.goalToCreate.goalType === PatientGoalNumberTypeEnum.VALUE) {
      this.goalToCreate.goalEnd = undefined;
    }
  }

  async onSelectMeasurement(value): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    const selected = this.optionsSearch.find(item => item._id === value);
    this.patientGoalType = selected.controlType;
    this.goalToCreate.valueStart = selected.currentValue;
    this.measurementUnitSymbol = selected.measureUnit?.symbol_es || null;
    this.goalToCreate.metadata = {
      controlType: selected.controlType,
      type: selected.type,
      userValues: selected.userValues,
      limits: selected.limits
    };
    this.goalToCreate.goalStart = undefined;
    this.goalToCreate.goalEnd = undefined;
    this.isValueRange = false;
    this.goalToCreate.measureUnitId = selected.measureUnit?._id;
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  onCancel(): void {
    this.cancel.emit(true);
  }

  onSave(): void {
    this.save.emit(this.goalToCreate);
  }

  onDeleteGoal(goal: Partial<IPostPatientGoal>, index: number, goalId: string): void {
    let message = '';
    if (this.goal.items.length === 1) {
      message = 'Estás a punto de eliminar el último elemento del progreso de la meta, si continúas será eliminada la meta por completo';
    } else {
      message = '¿Estás seguro de eliminar este elemento de la meta del paciente?';
    }
    this.modal.confirm({
      nzTitle: message,
      nzContent: 'Esta acción no se podrá deshacer.',
      nzOkText: 'SÍ QUIERO ELIMINARLA',
      nzCancelText: 'NO QUIERO',
      nzOkDanger: true,
      nzClassName: 'modal-confirm',
      nzClosable: false,
      nzOnOk: () => {
        this.goal.items.splice(index, 1);
        if (this.goal.items.length === 0) {
          this.deleteAll.emit(goalId);
        } else {
          this.delete.emit(goal);
        }
      },
      nzOnCancel: () => {
      }
    });
  }

  onDeleteGoalComplete(goal: IPatientGoal): void {
    this.modal.confirm({
      nzTitle: '¿Estás seguro de eliminar la meta del paciente?',
      nzContent: 'Esta acción no se podrá deshacer.',
      nzOkText: 'SÍ QUIERO ELIMINARLA',
      nzCancelText: 'NO QUIERO',
      nzOkDanger: true,
      nzClassName: 'modal-confirm',
      nzClosable: false,
      nzOnOk: () => {
        this.deleteAll.emit(goal._id);
      },
      nzOnCancel: () => {
      }
    });
  }
}
